import { Controller } from "@hotwired/stimulus"

// Shows a Bootstrap modal as soon as it is rendered, rather than waiting for a click.
// Used by the cross-site infringement warning, which the server renders in response to a
// submission the applicant has to acknowledge before it can continue (issue #167).
//
// modal_trigger_controller opens a modal on click; this is the show-on-render counterpart.
export default class extends Controller {
  connect() {
    Modal.getOrCreateInstance(this.element).show()
  }
}
